// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { Store, State } from '@ngrx/store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesFacadeService } from '@app/access-management/state/roles.facade';
import { DateTimePipe } from '@app/access-management/date-time.pipe';
import { Role, GoAction, QueueAlertAction, AlertType } from '@app/core';
import { SelectRoleAction, RemoveRoleByIdAction } from '@app/access-management/state';
import { RemoveRoleModalComponent } from './remove-role-modal/remove-role-modal.component';
import { RemoveResult } from '@app/access-management/shared/delete-modal/delete-modal.component';

@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.scss']
})
export class RolesListComponent implements AfterViewInit {
  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('dataTableAjax') dataTableAjax: DataTableAjaxComponent | undefined;

  columns: any[] = [];

  constructor(private store: Store<any>, private modalService: NgbModal, public roleFacade: RolesFacadeService) {
    this.roleFacade.initialize();
  }

  ngAfterViewInit() {
    this.columns = [
      {
        name: 'Role Name',
        prop: 'name',
        cellClass: 'text-info',
        flexGrow: 2
      },
      {
        name: 'Users',
        prop: 'numberOfUsers',
        flexGrow: 1
      },
      {
        name: 'Description',
        prop: 'description',
        flexGrow: 2
      },
      {
        name: 'Category',
        prop: 'category',
        flexGrow: 1
      }
    ];
  }

  onRowClicked({ selected }: { [selected: string]: Role[] }) {
    if (selected.length < 1) {
      return;
    }
    const selectedRole = selected[0];
    this.store.dispatch(new SelectRoleAction(selectedRole));
    this.store.dispatch(new GoAction(['/iam/roles', selectedRole.id]));
  }

  onClickRemoveAction(event: any, value: any) {
    event.preventDefault();
    event.stopPropagation();
    this.onRemoveRow(value);
  }

  onRemoveRow(removedId: string) {
    const modalRef = this.modalService.open(RemoveRoleModalComponent, { centered: true, windowClass: 'no-border' });
    modalRef.componentInstance.removedRoleId = removedId;
    // Wait for a result from the modal. Note, this method can't use async await, because it causes funny behavior
    // when called from an angular template
    const resultPromise = modalRef.result as Promise<RemoveResult>;
    resultPromise.then(result => {
      switch (result) {
        case RemoveResult.REMOVE_SUCCEEDED: {
          // Todo: if ACS server work is done, refresh role list will reflect new changes. [Verify need]
          this.store.dispatch(new RemoveRoleByIdAction(removedId));
          this.store.dispatch(
            new QueueAlertAction({ alertText: `Role delete succeed.`, alertType: AlertType.SUCCESS })
          );

          if (this.dataTableAjax) {
            this.dataTableAjax.refreshTable();
          }

          break;
        }

        case RemoveResult.REMOVE_FAILED: {
          this.store.dispatch(new QueueAlertAction({ alertText: `Role delete failed.`, alertType: AlertType.ERROR }));
          break;
        }

        default: {
          break;
        }
      }
    });
  }

  onEditClick(event: any, row: any) {
    event.preventDefault();
    event.stopPropagation();
    this.roleFacade.goToEditRole(row);
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/roles-list/roles-list.component.ts